import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Link from '@material-ui/core/Link';
import { footerHeight } from "./shareParams";

const useStyles = makeStyles(theme => ({
  root: {
    // height: `calc(2em + ${headerHeight}px)`,
    height: footerHeight,
    textAlign: "center",
    position : "relative"
  },
  content : {
    width : "100%",
    position : "absolute",
    top : "50%",
    left : "50%",
    transform : "translate(-50%, -50%)"
  }
}));

export const Footer = (props) => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div className={classes.content}>
        <Typography variant="body1">
          Copyright{" "}©{" "}
          <Link component="a" href="" target="_blank">
            2020星网智慧出品
          </Link>
        </Typography>
      </div>
    </div>
  );
};
